import { render, staticRenderFns } from "./EmptyComponent.vue?vue&type=template&id=3faa92e0&scoped=true"
import script from "./EmptyComponent.vue?vue&type=script&lang=js"
export * from "./EmptyComponent.vue?vue&type=script&lang=js"
import style0 from "./EmptyComponent.vue?vue&type=style&index=0&id=3faa92e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faa92e0",
  null
  
)

export default component.exports